import React from "react";
import styles from "./LocationButton.module.css";
import { RiDeleteBin4Line } from "react-icons/ri";
import { MdContentCopy } from "react-icons/md";

const LocationButton = ({ name, iconSrc, onDelete, onClick, onCopy }) => (
    <div
        className={`tw-flex tw-justify-between tw-items-center tw-mt-2 tw-px-3 tw-gap-3 tw-py-2 tw-bg-white tw-rounded-md tw-cursor-pointer hover:tw-bg-gray-50 tw-transition-colors`}
    >
        <button onClick={onClick} className={"tw-text-start tw-flex-1 tw-text-left tw-cursor-pointer"}>
            {name}
        </button>
        <div className="tw-flex tw-items-center tw-gap-2">
            <MdContentCopy
                onClick={(e) => {
                    e.stopPropagation();
                    onCopy();
                }}
                className={"tw-text-[18px] tw-cursor-pointer hover:tw-text-blue-500 tw-transition-colors"}
                title="Copy search"
            />
            <RiDeleteBin4Line
                onClick={(e) => {
                    e.stopPropagation();
                    onDelete();
                }}
                className={"tw-text-[18px] tw-cursor-pointer hover:tw-text-red-500 tw-transition-colors"}
                title="Delete search"
            />
        </div>
    </div>
);

export default LocationButton;
